import { h } from 'vue'

export default () => {
  return h('div', { class: 'border-bottom-1 border-300 my-2', style: 'height: 1px' })
}
